<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <!-- <h1 class="logo-name">FROTIX</h1> -->
    <img
      src="../../../public/img/icons/icon.png"
      alt=""
      width="150"
      height="150"
      class="mb-5"
    >

    <h3>FROTIX TESTAR</h3>

    <form class="m-t" role="form" novalidate v-on:submit.prevent>
      <div class="form-group" :class="{ 'has-error': errors.has('email') }">
        <input
          type="email"
          name="email"
          class="form-control"
          :placeholder="$t('email')"
          v-model="user.email"
          v-validate="'required|email'"
        >

        <small v-show="errors.has('email')" class="form-text text-muted text-left">
          {{ errors.first('email') }}
        </small>
      </div>

      <div class="input-group mb-3">
        <input
          :type="passwordFieldType"
          class="form-control"
          v-bind:placeholder="$t('password')"
          v-model="user.password"
          v-validate="'required'"
        >

        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-secondary"
            @click="passwordFieldType = passwordFieldType === 'text' ? 'password' : 'text'"
          >
            <span :class="[passwordFieldType === 'text' ? 'fas fa-eye-slash' : 'fas fa-eye']" />
          </button>
        </div>
      </div>

      <LoaderButton
        @click="onClick"
        :loading="isLoading"
        full
        type='submit'
      >
        {{ $t('login') }}
      </LoaderButton>

      <button
        type="button"
        class="btn btn-link btn-forget"
        data-toggle="modal"
        data-target="#modalForgetPassword"
      >
        Esqueci minha senha
      </button>
    </form>

    <div class="modal fade" id="modalForgetPassword" tabindex="-1" aria-labelledby="modalForgetPasswordLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalForgetPasswordLabel">Recuperação de senha</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-left">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="form-group text-left">
              <label for="emailRecover">{{ $t('email') }}</label>
              <input
                type="email"
                name="emailRecover"
                class="form-control"
                :placeholder="$t('type_email')"
                v-model="emailRecover"
              >
            </div>

            <p class="text-left">* Será enviado um link e instruções para redefinição de sua senha</p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('close') }}</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="recover"
            >
              <b-spinner small v-show="loading" />
              {{ loading ? $t('loading') : $t('send') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <p class="m-t">
      <small>Locadados Data Solutions &copy; 2008-{{ new Date().getFullYear() }}</small>
    </p>
    <p><small>v{{ version }}</small></p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import { addCls } from '@/lib/ui/domClass'
import { version } from '../../../package.json'

export default {
  name: 'Login',
  components: {
    LoaderButton
  },
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      version,
      passwordFieldType: 'password',
      emailRecover: '',
      alert: {
        show: false,
        type: '',
        message: ''
      },
      loading: false
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.session.isLoading
    })
  },

  methods: {
    ...mapActions('session', ['login', 'recoverPassword']),
    ...mapActions('notify', ['error']),

    async onClick (evt, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const error = new Error('Dados do formulário inválidos.')
        this.error(error)
        return
      }
      const logged = await this.login(this.user)
      if (logged) {
        this.$router.replace('main')
      }
    },

    showAlert(type, message) {
      this.alert = {
        show: true,
        type,
        message
      }
    },

    async recover() {
      if (!this.emailRecover) {
        return this.showAlert('danger', 'Informe o e-mail para recuperação!')
      }

      const errors = {
        'userNotFound'  : 'E-mail não encontrado!',
        'userBlocked'   : 'Usuário bloqueado!'
      }

      this.loading = true
      const { result, message } = await this.recoverPassword({ email: this.emailRecover })

      if (!result) {
        this.loading = false
        return this.showAlert('danger', errors[message] || 'Erro ao enviar e-mail de recuperação, tente novamente!')
      }

      this.showAlert('success', 'E-mail de recuperação enviado com sucesso!')

      this.emailRecover = ''
      this.loading = false
    }
  },

  mounted () {
    const global = this

    $('#modalForgetPassword').on('hide.bs.modal', function () {
      global.alert.show = false
      global.emailRecover = ''
    })
  },

  created () {
    addCls('body', 'gray-bg')
  }
}
</script>

<style scoped>
  .btn-forget {
    font-size: 14px !important;
  }
</style>
